import { Backdrop, CircularProgress, Container, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid } from '@material-ui/core'
import { createTheme, MuiThemeProvider } from '@material-ui/core/styles'
import { Search as SearchIcon } from '@material-ui/icons'
import { Button } from '@mui/material'
import MUIDataTable from "mui-datatables"
import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useQuery } from 'react-query'
import { useHistory } from 'react-router-dom'
import SelectPartNumber from '../../../components/Form/SelectPartNumber'
import SelectSupplier from '../../../components/Form/SelectSupplier'
import ButtonUI from '../../../components/ui/ButtonUI'
import PageTitle from '../../../components/ui/PageTitleUI'
import { useAuth } from '../../../hooks/auth'
import { MvmCriticalMaterialCallPut } from '../../../interfaces/Mvm'
import MvmApi from '../../../services/MvmApi'
import getDefaultGridOptions from '../../../utils/componentUtils'
import utilsDate from '../../../utils/Date'
import permissions from '../../../utils/Permissions'
import { useStyles } from './Style'

interface IFormInput {
    plantId: any;
    supplier: any;
    selectedpartnumber: any;
}

const CritialMaterialCall: React.FC = () => {
    const classes = useStyles()
    const history = useHistory()
    const { t: _t } = useTranslation("General")
    const { t: t } = useTranslation("Mvm")
    const [dialogOpen, setDialogOpen] = React.useState(false);
    const [openBackdrop, setOpenBackdrop] = React.useState(false);
    const [mvmInvoiceItemId, setMvmInvoiceItemId] = useState(0);
    const [id, setId] = useState(0);
    const {user, hasPermission} = useAuth();
    
    const { control: formControl, handleSubmit, watch, setError, clearErrors, getValues } = useForm<IFormInput>({
        defaultValues: {
            plantId: user.company?.plantID,
            supplier: {},
            selectedpartnumber: {},
        }
    });

    const { isLoading, isFetching, data, refetch } = useQuery('criticalMaterial', async () => {
        var filtros = getValues();
        return await MvmApi.CriticalMaterialCall(filtros.plantId, filtros.supplier?.code, filtros.selectedpartnumber?.partnumberCode);
    } ,{
        refetchIntervalInBackground: true,
        staleTime: 1000 * 60, //calculado em milisegundos - Propriedade para setar qto tempo o cache fica válido
        refetchInterval: 1000 * 60, //calculado em milisegundos - Propriedade para setar qto tempo vai buscar o cache novamente
    });

    useEffect(() => {
        if (!hasPermission(permissions.MVM.CriticalMaterialCall))
            history.replace('NoPermission');
    }, [history, user])

    const columns = [
        {
            name: 'criticalMaterialCallDate',
            label: '',
            options: {
                display: false,
            }
        },
        {
            name: 'mvmId',
            label: '',
            options: {
                display: false,
            }
        },
        {
            name: 'mvmInvoiceItemId',
            label: '',
            options: {
                display: false,
            }
        },
        {
            name: 'mvmId',
            label: ' ',
            options: {         
                customBodyRender: (value:any, tableMeta:any, updateValue:any) =>
                {
                    if(tableMeta.rowData[0] == '0001-01-01T00:00:00')
                    {
                       return (
                            <Button 
                                variant="outlined"
                                style={{height:"100%", width:"110%", fontSize:"0.7rem", padding:"2px"}}
                                onClick={() => handleDialogClickOpen(tableMeta.rowData[1], tableMeta.rowData[2])}>
                                   Chamar
                            </Button>
                        );
                    }
                    else
                    {   
                        return <span style={{minWidth:100}}>{"              "}</span>;
                    }
                }
            }
        },
        {
            name: 'conciergeCode',
            label: t("concierge"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                    }),
                setCellProps: () => ({
                    align: "center"
                }),
            }
        },
        {
            name: 'shedUnloadCode',
            label: t("shedUnloadCode"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                    }),
                setCellProps: () => ({
                    align: "center"
                }),
            }
        },
        {
            name: 'materialDescription',
            label:  t("partNumber"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                    }),
                setCellProps: () => ({
                    align: "center"
                }),
            }
        },
        {
            name: 'invoiceSupplier',
            label: t("supplier"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                    }),
                setCellProps: () => ({
                    align: "center"
                }),
            }
        },
        {
            name:  'mvmNumber',
            label: t("mvm"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                    }),
                setCellProps: () => ({
                    align: "center"
                }),
            }
        },{
            name: 'statusDescription',
            label: t("status"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                    }),
                setCellProps: () => ({
                    align: "center"
                }),
            }
        },{
            name: 'shippingCompanySupplier',
            label: t("shippingCompanySupplier"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                    }),
                setCellProps: () => ({
                    align: "center"
                }),
            }
        },{
            name: 'deliveryWindowDate',
            label: t("windowTime"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                    }),
                setCellProps: () => ({
                    align: "center"
                }), 
                customBodyRender: (value:any, tableMeta:any, updateValue:any) =>
                {
                    return <span>{value == "0001-01-01T00:00:00" ? '' : utilsDate.TimeShortByCompleteDate(new Date(value))}</span>;
                }
            }
        },{
            name: 'scheduleDate',
            label: t("presentationTime"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                    }),
                setCellProps: () => ({
                    align: "center"
                }), 
                customBodyRender: (value:any, tableMeta:any, updateValue:any) =>
                {
                    return <span>{value == "0001-01-01T00:00:00" ? '' : utilsDate.DateTime(new Date(value))}</span>;
                }
            }
        },{
            name: 'windowStatusDescription',
            label: t("windowStatus"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                    }),
                setCellProps: () => ({
                    align: "center"
                })
            }
        },
    ]

    const myTheme = createTheme({
        overrides: {
            MuiTableBody: {
                root: {
                    cursor: ''                    
                }
            },
            MuiTableCell: {
                root: {
                    paddingLeft: 4,
                    paddingRight: 4,
                    paddingBottom: 10,
                    paddingTop: 10
                },
                head: {
                    height: 52
                }
            }
        }
    })

    const handleDialogClickOpen = (id:number, mvmInvoiceItemId:number) => {
            setId(id);
        setMvmInvoiceItemId(mvmInvoiceItemId);
        setDialogOpen(true);
    };

    const handleDialogClickClose = () => {
        setOpenBackdrop(false);
        setDialogOpen(false);
    };

    const handleConfirmation = async() => {
        setOpenBackdrop(true);
        setDialogOpen(false);
        try{
            let dataPut: MvmCriticalMaterialCallPut = {
                id: id,
                mvmInvoiceItemId: mvmInvoiceItemId
            }
            const respUpdate = await MvmApi.CriticalMaterialCallPut(dataPut);
            refetch();
            setOpenBackdrop(false);
        }catch(error){
            setOpenBackdrop(false);
        }
    };

    const submit = async (data: any) => {
        refetch();
    }

    return (
        <Container maxWidth={false} component="main">
            <Backdrop className={classes.backdrop} open={openBackdrop || isLoading || isFetching}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <Dialog
                open={dialogOpen}
                onClose={handleDialogClickClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                {"Atenção"}
                </DialogTitle>
                <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    Confirma a chamada do material?
                </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDialogClickClose}>{"Cancelar"}</Button>
                    <Button onClick={() => handleConfirmation()} autoFocus>{"Sim"}</Button>
                </DialogActions>
            </Dialog>
            <PageTitle title={t("criticalMaterialCallTitle")} />

            <div className={classes.rootContent}>
                <div className={classes.paper}>
                    <form onSubmit={handleSubmit(submit)}>
                        <Grid container spacing={2}>
                            <Grid item xs={3}>
                                <SelectSupplier  name="supplier" control={formControl} multiline={false}/>
                            </Grid>
                            <Grid item xs={3}>
                                <SelectPartNumber 
                                label={t("partNumber")} name="selectedpartnumber" control={formControl} 
                                multiline={false}
                                groupItens={true}
                                companyBOMCode=""/>
                            </Grid>
                            <Grid item xs={2} >
                                <ButtonUI
                                    color="primary"
                                    type="submit"
                                    variant="contained"
                                    startIcon={<SearchIcon />}
                                    >
                                    {_t("search")}
                                </ButtonUI>
                            </Grid>
                        </Grid>
                    </form>
                    {
                        
                            <MuiThemeProvider theme={myTheme}>
                                <MUIDataTable
                                    title=""
                                    data={data}
                                    columns={columns} 
                                    options={{
                                        ...getDefaultGridOptions(_t),
                                        serverSide: true,
                                        pagination: false,
                                        sort: false,
                                        selectToolbarPlacement: "none",
                                        filter: false,
                                        search: false,
                                        download: true,
                                        print: false,
                                        viewColumns: false,
                                        selectableRows: 'none',
                                       
                                    }}
                                    
                                />
                            </MuiThemeProvider>
                    }
                </div>
            </div>
        </Container>
    )
}
export default CritialMaterialCall;
